import { ComponentStyleConfig } from "@chakra-ui/react";

export const Divider: ComponentStyleConfig = {
  baseStyle: {
    borderWidth: "2px",
    borderColor: "neon.200",
    opacity: "1",
  },
};
